import { axios } from "~/plugins/axios";

const APP_NAME = process.env.VUE_APP_APP_NAME

const DEFAULT_USER = {
  username: 'Гость',
  email: 'Гость',
  role: { name: 'guest' },
  permissions: [],
}

const getDefaultState_User = () => {
  return {
    currentUser: DEFAULT_USER,
    sideMenu: [],
  }
}
const state = getDefaultState_User();

const getters = {
  currentUser(state) {
    return state.currentUser
  },

  hasRole: (state) => (roles) => {
    return roles.includes(state.currentUser.role?.name) ||
      roles.includes('any') ||
      state.currentUser.role?.name == 'admin'
  },

  hasRole2: (state) => (roles) => {
    return roles.includes(state.currentUser.role?.name) || roles.includes('any')
  },

  hasPermission: (state) => (permissions) => {
    const granted = state.currentUser.permissions || []

    if (Array.isArray(permissions)) {
      return permissions.some(p => granted.includes(p))
    }

    return granted.includes(permissions)
  },

  // sideMenus() {


  //   // return [
  //   //   { title: 'Поиск по фразам', icon: 'mdi-magnify', roles: ['admin', 'leader', 'manager', 'supervisor', 'customer'], url: '/stat/speech-analysis/transcribe-search' },
  //   //   { title: 'Прослушка', icon: 'mdi-rabbit', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/speech-analysis/wiretapping-rate' },
  //   //   { title: 'Проектный сервис', icon: 'mdi-view-list', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/project-service' },
  //   //   { title: 'Вызовы', icon: 'mdi-phone', roles: ['admin', 'leader', 'manager', 'supervisor', 'operator_customer'], url: '/stat/speech-analysis/report/' },
  //   //   { title: 'Список вызовов', icon: 'mdi-phone', roles: ['admin', 'leader', 'manager', 'supervisor', 'customer'], url: '/stat/speech-analysis/report_customer' },
  //   //   { title: 'Отчет по тарифам', icon: 'mdi-currency-rub', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/tariffications/report' },
  //   //   { title: 'Отчет по качеству операторов', icon: 'mdi-account-supervisor', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/operators/report' },
  //   //   { title: 'Матрица', icon: 'mdi-matrix', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/OperatorsMatrix' },
  //   //   { title: 'Таймлайны', icon: 'mdi-chart-timeline', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/OperatorsTimeline' },
  //   //   { title: 'Занятость', icon: 'mdi-cash-100', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/OperatorsEmployment' },
  //   //   { title: 'Игноры', icon: 'mdi-skip-next', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/OperatorsIgnore' },
  //   //   { title: 'По дням', icon: 'mdi-calendar-today', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/by-days' },
  //   //   { title: 'По формам', icon: 'mdi-form-select', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/form-report' },
  //   //   { title: 'Статистика по формам', icon: 'mdi-form-select', roles: ['admin', 'leader', 'manager', 'supervisor'], url: '/stat/form-statistic-report' },
  //   // ]
  // },

  topMenus() {
    return [
      { title: 'Профиль', icon: 'mdi-account', roles: ['any'], url: '/me' },
    ]
  },

  sideMenu: (state) => state.sideMenu,
}

const actions = {
  async loadCurrentUser({ commit, state }, query) {
    commit('shared/SET_LOADING', true, { root: true })

    try {
      const resp = await axios.post('/api/auth/me', { app: APP_NAME }, { params: query || {}, noAuthRetry: true })
      commit('SET_CURRENT_USER', resp.data.data)

      return state.currentUser
    } finally {
      commit('shared/SET_LOADING', false, { root: true })
    }
  },

  clear({ commit }) {
    commit('RESET_STATE_USER')
  },

  async getUser() {
    if (this.getters.currentUser === null) {
      await this.dispatch('loadCurrentUser')
    }
    return this.state.currentUser
  },

  async hasPermissionTo({ commit }, { permissionName }) {
    commit('shared/SET_LOADING', true, { root: true })
    try {
      let resp = axios.post('/api/auth/hasPermissionTo', { permissionName: permissionName })
      commit('shared/SET_LOADING', false, { root: true })

      return resp

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, { root: true })
      commit('shared/SET_LOADING', false, { root: true })

      throw err
    }
  },

  updatePassword({ commit }, payload) {
      return axios.post('/api/me/change-password', payload)
          .then(response => {
              commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
              commit('shared/SET_LOADING', false, { root: true })
          })
          .catch(err => {
              commit('shared/SET_ERROR', err.response.data, { root: true })
              commit('shared/SET_LOADING', false, { root: true })

              throw err
          })
  },

  sendCodeRequest({ commit }, type) {
    return axios.post('/api/me/request-confirmation-code', {
      type: type,
    })
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        commit('shared/SET_LOADING', false, { root: true })
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },

  changeEmail({ commit }, payload) {
    return axios.post('/api/me/change-email', payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        commit('shared/SET_LOADING', false, { root: true })
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },

  changeTelegram({ commit }, payload) {
    return axios.post('/api/me/change-telegram', payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        commit('shared/SET_LOADING', false, { root: true })
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },

  changePhoneNumber({ commit }, payload) {
    return axios.post('/api/me/change-phone-number', payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        commit('shared/SET_LOADING', false, { root: true })
        return response.data.message;
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },

  sendConfirm({ commit }, payload) {
    return axios.post(`/api/me/confirm?token=${payload.token}&type=${payload.type}`)
      .then(response => {
        if (payload.type === 2) {
          commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        }

        commit('shared/SET_LOADING', false, { root: true })
        return response.data.message;
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },

  changeAuthSender({ commit }, type) {
    commit('shared/SET_LOADING', true, { root: true })
    return axios.post(`/api/me/change-auth-sender`, {
      type: type,
    })
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
        commit('shared/SET_LOADING', false, { root: true });
      });
  },

  loadSideMenu({ commit }) {
    return axios.post('/api/reports/menu')
      .then(response => {
        commit('SET_SIDE_MENU', response.data)
        return response.data
      })
      .catch(err => {
        commit('shared/SET_ERROR', err.response.data, { root: true })
        commit('shared/SET_LOADING', false, { root: true })

        throw err
      })
  },
}

const mutations = {
  SET_CURRENT_USER(state, payload) {
    if (payload) {
      state.currentUser = payload
    } else {
      state.currentUser = DEFAULT_USER
    }
  },

  SET_SIDE_MENU(state, payload) {
    state.sideMenu = payload
  },


  RESET_STATE_USER (state) {
    Object.assign(state, getDefaultState_User())
  },
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
